/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
var search_rslib_entry_SearchProvider = /*#__PURE__*/ function(SearchProvider) {
    SearchProvider["BrowserSearch"] = "browser_search";
    SearchProvider["BingSearch"] = "bing_search";
    SearchProvider["Tavily"] = "tavily";
    SearchProvider["DuckduckgoSearch"] = "duckduckgo_search";
    SearchProvider["SearXNG"] = "searxng";
    return SearchProvider;
}({});
export { search_rslib_entry_SearchProvider as SearchProvider };

//# sourceMappingURL=search.mjs.map